module.exports = __webpack_public_path__ + "aa5d774f8475f716e79b25e89516dfbd.jpg";